import React from 'react';
import { IfmsRoute }from '../../../config/types';
import BTOrderBillingsView from '../order/BTOrderBillingsView';
import BTLoadPlanBillingsView from '../loadPlan/BTLoadPlanBillingsView';

export const BTOrderView = React.lazy(() => import("../order/BTOrderView"));
export const BTLoadPlanView = React.lazy(() => import('../loadPlan/BTLoadPlanView'));
export const BTLocalDOView = React.lazy(() => import('../localDO/BTLocalDOView'));
export const FolderLabelView = React.lazy(() => import('../../reports/FolderLabelView'));
export const CargoManifestStatusView = React.lazy(() => import('../../reports/CargoManifestStatusView'));

const routes:Array<IfmsRoute> = [
  { path: '/brokerageTrucking/order/:mode/:id?/:tabIndex?/:createEntity?/:showIQ?', component: BTOrderView },
  { path: '/brokerageTrucking/loadPlan/:mode/:id?/:tabIndex?/:createEntity?', component: BTLoadPlanView },
  { path: '/brokerageTrucking/localDO/:mode/:id?/:tabIndex?/:createEntity?/:rowIndex?', component: BTLocalDOView },
  { path: '/brokerageTrucking/viewBillings/order/:id?', component: BTOrderBillingsView},
  { path: '/brokerageTrucking/viewBillings/loadPlan/:id?', component: BTLoadPlanBillingsView },
  // Moremunu
  { path: '/brokerageTrucking/folderLabel', component: FolderLabelView },
  { path: '/brokerageTrucking/cargoManifestStatus', component: CargoManifestStatusView },
];

export default routes;
